import {IUserTicketPrize} from "../../../firebase/topics/in-game-challenges/tickets-update/user-tickets-update-topic.model.interface";

// All possible prize types taken from this page:
// https://evokeplc.atlassian.net/wiki/spaces/CRMSX/pages/1317634384/CRM+exposed+contracts
// enBonusType
export enum InGameTicketPrizeType {
    ImmediateBonus = 1,
    PendingBonus = 2,
    TournamentTicketBonus = 7,
    FreePlayVoucher = 10,
    FreePlayFreeSpins = 11,
    ClaimBonus = 12,
    FreeBet = 13, // Kambi Free Bet
    JackpotFreePlayVoucher = 14, // Jackpot Freeplay Voucher
    JackpotFreeSpins = 15, // Jackpot Free Spins
    ThirdPartyFreePlayFreeSpins = 16, // 3rd Party Free spins
    SpectateFreeBet = 17, // Spectate Free Bet
    ThirdPartyFreePlayVoucher = 18, // Third party free play voucher
    NoWin = 19, // No win ( No bonus amount)
    GoldToken = 20, // Point Based bonus
    LoyaltyPoints = 21, // Point Based Bonus
    SICoverVoucher = 22,
    SITix = 23,
    IGCTicket = 24,
}

export interface IInGameTicketPrize extends IUserTicketPrize {
    prizeString(): string;
    isEqual(p: IUserTicketPrize): boolean;
    toString(): string;
}
